import { html, TemplateResult } from "lit-html";
import { SearchPassengers } from "Shared/managers/current-search-manager/CurrentSearch";

export const maxChildrenAmount = (passengers: SearchPassengers): number => {
	if (passengers.adults > 0) return Number.POSITIVE_INFINITY;

	const retVal = passengers.teens - passengers.infants;

	return retVal > 0 ? retVal : 0;
};

export const maxInfantAmount = (passengers: SearchPassengers): number => {
	if (passengers.adults > 0) return passengers.adults + passengers.teens;

	const retVal = passengers.teens - passengers.children;

	return retVal > 0 ? retVal : 0;
};

export interface PassengerRowDto {
	amount: number;
	info: string;
	isAddDisabled: boolean;
	isRemoveDisabled: boolean;
	label: string;
	onDecrease: () => void;
	onIncrease: () => void;
}

export const passengerRowTemplate = (dto: PassengerRowDto): TemplateResult => html`
	<div class="mb-4 flex w-full items-center justify-between">
		<div>
			<div class="font-body text-base font-bold text-n-blue">${dto.label}</div>
			<div class="font-body text-xs text-[#a1a1a1]">${dto.info}</div>
		</div>
		<div class="grid grid-cols-[24px_24px_24px] grid-rows-[24px]">
			<ac-change-passenger-number-button
				.type=${"minus"}
				.isDisabled=${dto.isRemoveDisabled}
				.onClick=${dto.onDecrease}
			></ac-change-passenger-number-button>
			<div class="flex h-full w-full items-center justify-center font-body text-sm font-bold">${dto.amount}</div>
			<ac-change-passenger-number-button
				.type=${"plus"}
				.isDisabled=${dto.isAddDisabled}
				.onClick=${dto.onIncrease}
			></ac-change-passenger-number-button>
		</div>
	</div>
`;
